// Date列配置
export const DATE_COLUMN = {
  code: 'date',
  width: 120,
  align: 'left',
  lock: true,
  features: { sortable: true },
  name: 'Date',
}
